var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuatemala({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_8383)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 7.24245 21.2313 3.1317 17.2174 1.1907V22.8092C21.2313 20.8683 24 16.7575 24 12Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 16.7575 2.76867 20.8683 6.78263 22.8093V1.1907C2.76867 3.1317 0 7.24245 0 12Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1358 14.0291L13.1068 12.0001L15.0382 10.0686L14.9507 9.04851L14.3977 8.49548L12 10.8932L9.60225 8.49548L9.04931 9.04851L8.96179 10.0686L10.8932 12.0001L8.86411 14.0291L9.97092 15.1358L12 13.1069L14.0291 15.1358L15.1358 14.0291Z",
    fill: "#ACABB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9514 9.04861L13.8446 10.1554C14.3167 10.6275 14.6087 11.2796 14.6087 12C14.6087 13.4408 13.4408 14.6087 12 14.6087C10.5593 14.6087 9.39131 13.4408 9.39131 12C9.39131 11.2796 9.68335 10.6275 10.1554 10.1554L9.04866 9.04861C8.29327 9.80386 7.82611 10.8473 7.82611 12C7.82611 14.3052 9.69483 16.1739 12 16.1739C14.3052 16.1739 16.1739 14.3052 16.1739 12C16.1739 10.8474 15.7067 9.80391 14.9514 9.04861Z",
    fill: "#6DA544"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_8383"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuatemala);
export default __webpack_public_path__ + "static/media/guatemala.aa3b85d77f792a62e97c948fb7dcf796.svg";
export { ForwardRef as ReactComponent };